import { useState, useEffect } from 'react'
import { URL_DPV_OFFERS } from '@/config/account'
import { getBreakpoint } from '@/utils/app/detect'

export const useDpvAboLink = () => {
  const onweweDefault = '0605'
  const onwewMobile = '0606'
  const [onwewe, setOnwewe] = useState<string>(onweweDefault)

  useEffect(() => {
    if (getBreakpoint() === 'xs') setOnwewe(onwewMobile)
  }, [])

  return URL_DPV_OFFERS + '?onwewe=' + onwewe
}
